import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QualValOffering from "@/pages/QualValOffering";

export const Route = createFileRoute("/es/servicios/qualification-validation/soporte-de-procesos-y-productos")({
  head: () => buildRouteHead("/es/servicios/qualification-validation/soporte-de-procesos-y-productos"),
  component: QualValOffering,
});

